module.exports = "<h1 jhiTranslate=\"grid.faculty.title\">Queuing systems are available at:</h1> <qms-tile *ngFor=\"let faculty of faculties\" [routerLink]=\"['/faculty-queues-state', faculty.id]\" [model]=\"faculty\"> </qms-tile> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/home/faculties-grid/faculties-grid.component.html
// module id = 226
// module chunks = 0